import { createSlice } from "@reduxjs/toolkit";
import { getStoredAuth } from "../api/auth";

const stored = getStoredAuth();

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: stored?.user || null,
    token: stored?.token || null,
    isAuthenticated: !!stored,
    isInitializing: true,
  },
  reducers: {
    setCredentials: (state, action) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.isAuthenticated = true;
    },
    clearCredentials: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
    },
    setInitialized: (state) => {
      state.isInitializing = false;
    },
  },
});

export const { setCredentials, clearCredentials, setInitialized } = authSlice.actions;
export default authSlice.reducer;
